import { render, staticRenderFns } from "./VisualizarTerritorio.vue?vue&type=template&id=968510d8&lang=pug"
import script from "./VisualizarTerritorio.vue?vue&type=script&lang=js"
export * from "./VisualizarTerritorio.vue?vue&type=script&lang=js"
import style0 from "./VisualizarTerritorio.vue?vue&type=style&index=0&id=968510d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports